'use es6';

export const O365_KEY = 'sidekick:clients:o365:addin:version';
export const VSTO_KEY = 'sidekick:clients:outlook:addin:version';